
import { getBaseInfo } from '@/api/xiqueClinc'
import { getaddlog } from '@/api/hgfw'
import config from '@/config/index'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'





import { getdoctorlist } from '@/api/pengchengxinli'
export default {
directives: {
TransferDom
},
components: { XDialog },
data () {
return {
baseUrl: config.baseUrl,
obj: {},
showInfo: false,
doctorList: [],
defaultImg:
'this.src="' + require('../../assets/pengchengxinli/404.jpg') + '"',






















newsList: [],
pageCurrent: 1,
moremsg: '点击加载更多',
nomore: false
}
},
mounted () {
this.getInfo()
this.addLog()
this.getlistNow()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},

userCertType () {
return this.$store.state.user.userCertType
}
},
methods: {
getMore (index) {
this.$set(this.doctorList[index], 'show', !this.doctorList[index].show)
},
detail (id) {
this.$router.push({ name: 'yzDetail', params: { type: id } })
},
loadmore () {
if (!this.nomore) {
this.moremsg = '正在加载中...'
this.pageCurrent++
this.getNews()
}
},
consult (index) {
this.$router.push({ name: 'pengchengxinliZhuanjia', params: { id: index } })
},

addLog () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120118
})
},
getInfo () {

getBaseInfo({
clinicid: 1025
}).then(res => {
if (res.status === 'suc') {
this.obj = res.returnValue
}
})
},
getlistNow () {
getdoctorlist({
rows: 4
}).then(data => {
this.doctorList = data.obj
})
}
}
}
